import type { TProps } from '../t'

import { useStyleConfig, vui } from '../core'
import T from '../t'
import { cs } from '../utils'
import { useNotificationContext } from './context'

/** Displays text within the Notification. */
export const NotificationText = vui<'p', TProps>((props, ref) => {
  const { className, ...rest } = props
  const styles = useStyleConfig('Notification', useNotificationContext())

  return <T className={cs('vui-notificationText', className)} ref={ref} {...styles.text} {...rest} />
})

NotificationText.displayName = 'NotificationText'
export default NotificationText
